var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationWebService(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 13c-1.103 0-2 .897-2 2v40c0 1.103.897 2 2 2h56c1.103 0 2-.897 2-2V15c0-1.103-.897-2-2-2H12zm56 46H12c-2.206 0-4-1.794-4-4V15c0-2.206 1.794-4 4-4h56c2.206 0 4 1.794 4 4v40c0 2.206-1.794 4-4 4z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M48.042 68.287l-3-10 1.916-.574 3 10-1.916.574M31.958 68.287l-1.916-.574 3-10 1.916.574-3 10",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M27 69h26v-2H27zM39 55h2v-2h-2zM14 49h52V17H14v32zm53 2H13a1 1 0 01-1-1V16a1 1 0 011-1h54a1 1 0 011 1v34a1 1 0 01-1 1z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 37.412l7 3.888v-7.712L32 29.7v7.712zm8.485-15.286l8.998 4.998A.998.998 0 0150 28v10a.999.999 0 01-.515.874l-8.97 4.984a1.003 1.003 0 01-.008.004l-.015.007-.105.053a.998.998 0 01-.872-.048l-9-5A.999.999 0 0130 38V28c0-.354.188-.682.493-.862l.023-.013 8.999-4.999c.3-.168.67-.168.97 0zM48 29.7l-7 3.886v7.713l7-3.887V29.7zm-8-5.556l-6.942 3.855L40 31.855l6.941-3.856L40 24.144z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationWebService;